import { AfterViewInit, Component, Input, TemplateRef } from '@angular/core';
import {
  CcpcGameResults,
  CcpcSubmissionType,
  GameLanguage,
  GameType,
} from '@codecraft-works/data-models';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-ccpc-tournament-match',
  templateUrl: './ccpc-tournament-match.component.html',
  styleUrls: ['./ccpc-tournament-match.component.css'],
})
export class CcpcTournamentMatchComponent implements AfterViewInit {
  @Input()
  match: CcpcGameResults;

  @Input()
  type: CcpcSubmissionType;

  language: GameLanguage;

  gameType: GameType;

  modalRef: any;

  @Input()
  showWinner = true;

  @Input()
  includeLinksToPlayers = false;

  constructor(private modalService: BsModalService) {}

  ngAfterViewInit(): void {
    switch (this.type) {
      case CcpcSubmissionType.TICTACTOE_JAVA:
        this.language = GameLanguage.JAVA;
        this.gameType = GameType.TICTACTOE;
        break;
      case CcpcSubmissionType.TICTACTOE_BLOCKLY:
      case CcpcSubmissionType.TICTACTOE_PYTHON:
        this.language = GameLanguage.PYTHON;
        this.gameType = GameType.TICTACTOE;
        break;
      case CcpcSubmissionType.BATTLESHIP_JAVA:
        this.language = GameLanguage.JAVA;
        this.gameType = GameType.BATTLESHIP;
        break;
      default:
        break;
    }
  }

  openModal(modalName: TemplateRef<any>, modalClass = 'modal-lg') {
    this.modalRef = this.modalService.show(modalName, {
      class: `${modalClass} modal-dialog modal-dialog-centered`,
      animated: true,
    });
  }

  emoji(playerName: string) {
    if (this.match.winner === playerName && this.showWinner) {
      return '⭐ Winner!';
    } else {
      return '';
    }
  }
}
